module.exports = __webpack_public_path__ + "a.no2.7a35d5c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/a.no2.jpg
// module id = L7oM
// module chunks = 0